<template>
  <form @submit.prevent="submit($event)" ref="form" >
    <slot/>
  </form>
</template>

<script>
export default {
  name: 'Form',
  props: {
    submit_name: {
      type: String,
      default: 'submit'
    },
    // refs: Object,
  },
  data() {
    return {
      refs: {}
    }
  },
  mounted() {
    this.$emit('mounted')
  },
  methods: {
    clear() {
      const form_data = new FormData(this.$refs.form)
      for (const pair of form_data.entries()) {
        if(this.refs[pair[0]]) {
          this.refs[pair[0]].clear()
        }
      }
      // Object.keys(this.refs).forEach(key=>{
      //   if(key!=='submit') {
      //     this.refs[key].clear()
      //   }
      // })
    },
    submit() {
      const form_data = new FormData(this.$refs.form)
      var has_client_error = false
      const error_input_labels = []
      for (const pair of form_data.entries()) {
        // console.log(pair)
        if(this.refs[pair[0]]?.error) {
          has_client_error = true
          error_input_labels.push(this.refs[pair[0]].label)
          this.refs[pair[0]].showError()
        }
      }
      if(has_client_error) {
        this.refs[this.submit_name].setErrorMessage(`Error(s) for input(s): ${error_input_labels.join(', ')}`)
        return
      }
      this.refs[this.submit_name].setErrorMessage(null)
      this.$emit('fsubmit',form_data)
    },
  },
}
</script>


<style scoped lang="scss">
@import 'D:\\inetpub\\MPortal\\src\\_variables';

</style>
